/**
* @internal
* 
* @deprecated This is an internal API and should not be used directly. This can be removed or changed at any time.
*/
export function graphQLResultHasError(result) {
    return !!result.errors?.length;
}
//# sourceMappingURL=graphQLResultHasError.js.map
